<template>
	<main>
		<HeaderTab :title="$t('contact.title')" :icon="['fal', 'phone']" />
		<div id="content">
			<div class="container-fluid">
				<div class="row">
					<div class="col-12 col-lg-6 mb-4 d-flex">
						<div class="box contact-card w-100">
							<h2 class="contact-card-title">
								<font-awesome-icon :icon="['fal', 'phone']" class="mr-2" />
								{{ $t('contact.contactus_title') }}
							</h2>
							<div v-if="contactus_content" class="contact-content" v-html="contactus_content"></div>
							<div v-else class="contact-empty">
								<font-awesome-icon :icon="['fal', 'info-circle']" />
								<p>{{ $t('contact.no_content') }}</p>
							</div>
						</div>
					</div>

					<div class="col-12 col-lg-6 mb-4 d-flex">
						<div class="box contact-card w-100">
							<h2 class="contact-card-title">
								<font-awesome-icon :icon="['fal', 'calendar']" class="mr-2" />
								{{ $t('contact.openhours_title') }}
							</h2>
							<ul v-if="has_open_days" class="contact-hours">
								<li
									v-for="(hours, idx) in openDays"
									:key="idx"
									class="contact-hours-item"
									:class="{ 'is-today': idx === today_index, 'is-closed': !hours }"
								>
									<span>{{ day_names[idx] }}</span>
									<span class="contact-hours-value">{{ hours || $t('contact.closed') }}</span>
								</li>
							</ul>
							<div v-else class="contact-empty">
								<font-awesome-icon :icon="['fal', 'info-circle']" />
								<p>{{ $t('contact.no_content') }}</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</main>
</template>

<script>
import Contract from '@/mixins/Contract.js'
import xss from 'xss'

export default {
	name: 'ContactUs',
	mixins: [Contract],
	data() {
		return {
			contactus_fr: '',
			contactus_en: '',
			openDays: [],
		}
	},
	computed: {
		/** Contenu HTML de la page Contact selon la langue active (fr/en), sanitisé contre le XSS. */
		contactus_content() {
			const lang = this.getConfig('lang') ?? 'fr'
			const raw = lang === 'en' ? this.contactus_en : this.contactus_fr
			return xss(raw)
		},
		/** Noms localisés des jours de la semaine (lundi → dimanche) via i18n. */
		day_names() {
			return [0, 1, 2, 3, 4, 5, 6].map(i => this.$t(`contact.days.${i}`))
		},
		/** Vrai dès qu'au moins un jour possède des horaires saisis. */
		has_open_days() {
			return this.openDays.some(hours => hours)
		},
		/** Index du jour courant dans openDays, qui commence au lundi contrairement à getDay(). */
		today_index() {
			return (new Date().getDay() + 6) % 7
		},
	},
	created() {
		this.init_component()
	},
	methods: {
		/**
		 * Charge les données de contact depuis la configuration de la politique de confidentialité :
		 * contenu HTML FR/EN et horaires d'ouverture.
		 */
		async init_component() {
			const data = await this.contractPrivacyPolicy()
			if (!data) return
			this.contactus_fr = data.contactus_fr || ''
			this.contactus_en = data.contactus_en || ''
			const days = data.openDays
			if (Array.isArray(days)) {
				this.openDays = days
			} else if (days) {
				try { this.openDays = JSON.parse(days) } catch { this.openDays = [] }
			}
		},
	},
	components: {
		HeaderTab: () => import('@/components/HeaderTab'),
	},
}
</script>
